/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocMinusIcon16Light } from './DocMinusIcon16Light';
import { DocMinusIcon16Regular } from './DocMinusIcon16Regular';
import { DocMinusIcon16Solid } from './DocMinusIcon16Solid';
import { DocMinusIcon20Light } from './DocMinusIcon20Light';
import { DocMinusIcon20Regular } from './DocMinusIcon20Regular';
import { DocMinusIcon20Solid } from './DocMinusIcon20Solid';
import { DocMinusIcon24Regular } from './DocMinusIcon24Regular';
import { DocMinusIcon24Solid } from './DocMinusIcon24Solid';
import { DocMinusIcon32Regular } from './DocMinusIcon32Regular';
import { DocMinusIcon64Regular } from './DocMinusIcon64Regular';
var sizes = {
    16: {
        light: DocMinusIcon16Light,
        regular: DocMinusIcon16Regular,
        solid: DocMinusIcon16Solid,
    },
    20: {
        light: DocMinusIcon20Light,
        regular: DocMinusIcon20Regular,
        solid: DocMinusIcon20Solid,
    },
    24: {
        regular: DocMinusIcon24Regular,
        solid: DocMinusIcon24Solid,
    },
    32: {
        regular: DocMinusIcon32Regular,
    },
    64: {
        regular: DocMinusIcon64Regular,
    },
};
export var DocMinusIcon = forwardRef('DocMinusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
